module.exports = __webpack_public_path__ + "static/img/mar.8579a36e.webp";